import { render, staticRenderFns } from "./ContactAdd.vue?vue&type=template&id=43450de2"
import script from "./ContactAdd.vue?vue&type=script&lang=js"
export * from "./ContactAdd.vue?vue&type=script&lang=js"
import style0 from "./ContactAdd.vue?vue&type=style&index=0&id=43450de2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports